export type OpeningSentenceParts = {
  highlightText: string;
  impactWords: string[];
};

export const parseOpeningSentence = (
  openingSentence: string | undefined,
  defaultOpeningSentence: string,
): OpeningSentenceParts => {
  const sentenceParts = (openingSentence ?? defaultOpeningSentence)
    .split('\n')
    .map((part) => part.trim())
    .filter((part) => part.length > 0);

  const highlightText = sentenceParts[0] ?? 'a year of';
  const remainingParts = sentenceParts.slice(1);
  const impactWords =
    remainingParts.length > 0
      ? remainingParts
      : ['impact', 'and', 'achievement'];

  return { highlightText, impactWords };
};
